/* Olyra Shoulder Wrap : tiroir panier AJAX (structure Maeven). Ouvert après « Add to cart » (window.OlySwCart.open, appelé par oly-sw.js)
   et par l'icône panier de l'en-tête (.pv-head__cart). Les lots se choisissent dans Moon Bundle (22/10) : le tiroir affiche le panier tel quel.
   Ne rend que le contenu réel de /cart.js. Se ré-initialise sur shopify:section:load. */
(function () {
  var d, panel, opener = null, cmp = {}, loading = null;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function $(s, el) { return (el || d).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function api(path, body) {
    var o = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' };
    return fetch(root() + path, o).then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); });
  }
  function group(s, sep) { return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s; }
  function fmt(cents) {
    var s = ($('[data-swc-money]') || {}).textContent || '', n = Math.abs(Math.round(cents)), neg = cents < 0 ? '-' : '';
    var m = s.match(/^([\s\S]*?)12(\D?)345(\D)67([\s\S]*)$/);
    if (m) return neg + m[1] + group(String(Math.floor(n / 100)), m[2]) + m[3] + ('0' + (n % 100)).slice(-2) + m[4];
    m = s.match(/^([\s\S]*?)12(\D?)346([\s\S]*)$/);
    if (m) return neg + m[1] + group(String(Math.round(n / 100)), m[2]) + m[3];
    return neg + (n / 100).toFixed(2);
  }
  function img(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160' : ''; }
  function badge(n) {
    document.querySelectorAll('.pv-head__cart').forEach(function (a) {
      var c = a.querySelector('.pv-head__count');
      if (n > 0) { if (!c) { c = document.createElement('span'); c.className = 'pv-head__count'; a.appendChild(c); } c.textContent = n; }
      else if (c) c.remove();
    });
  }
  function render(cart) {
    var L = d.dataset, items = cart.items || [], was = 0, h = '';
    items.forEach(function (it) {
      var c = (cmp[it.variant_id] || 0) * it.quantity, t = it.final_line_price, rc = c > t ? c : t;
      was += rc;
      h += '<div class="swc-line" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
        '<div class="swc-line__img">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" width="68" height="68" loading="lazy">' : '') + '</div>' +
        '<div><p class="swc-line__name">' + esc(it.product_title) + '</p>' +
        (it.product_has_only_default_variant || !it.variant_title ? '' : '<p class="swc-line__opt">' + esc(it.variant_title) + '</p>') +
        '<div class="swc-qty"><button type="button" data-swc-dec aria-label="' + esc(L.lDec) + '">−</button><span>' + it.quantity + '</span><button type="button" data-swc-inc aria-label="' + esc(L.lInc) + '">+</button></div></div>' +
        '<div class="swc-line__right"><div class="swc-line__price">' + esc(fmt(t)) + '</div>' +
        (c > t ? '<s class="swc-line__was">' + esc(fmt(c)) + '</s><span class="swc-line__save">' + esc(L.lSave) + ' ' + esc(fmt(c - t)) + '</span>' : '') +
        '<button type="button" class="swc-line__rm" data-swc-rm>' + esc(L.lRemove) + '</button></div></div>';
    });
    $('[data-swc-items]').innerHTML = h;
    $('[data-swc-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    $('[data-swc-empty]').hidden = items.length > 0;
    $('[data-swc-foot]').hidden = items.length === 0;
    var tot = cart.total_price, sv = was - tot;
    $('[data-swc-total]').textContent = fmt(tot);
    $('[data-swc-was]').textContent = sv > 0 ? fmt(was) : '';
    var s = $('[data-swc-saved]'); s.hidden = !(sv > 0); s.textContent = sv > 0 ? L.lSaved + ' ' + fmt(sv) : '';
    badge(cart.item_count);
  }
  function msg(t) { $('[data-swc-msg]').textContent = t || ''; }
  function trust() {
    var buy = document.querySelector('[data-sw-buy]'), sec = buy && buy.closest('section'), ul = $('[data-swc-trust]'), pay = $('[data-swc-pay]');
    ul.innerHTML = ''; pay.innerHTML = '';
    if (!sec) return;
    sec.querySelectorAll('.sw-reass li').forEach(function (li) {
      var i = li.querySelector('span'), t = li.cloneNode(true), x = t.querySelector('small'), e = t.querySelector('span');
      if (x) x.remove(); if (e) e.remove();
      var n = document.createElement('li'); n.textContent = (i ? i.textContent.trim() + ' ' : '') + t.textContent.trim(); ul.appendChild(n);
    });
    sec.querySelectorAll('.sw-pay svg').forEach(function (v) { pay.appendChild(v.cloneNode(true)); });
  }
  function focusables() { return Array.prototype.filter.call(panel.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'), function (e) { return e.offsetParent !== null; }); }
  function open() {
    if (!d.classList.contains('is-open')) opener = document.activeElement;
    d.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('swc-lock');
    var c = $('.swc-close'); if (c) c.focus({ preventScroll: true });
  }
  function close() {
    if (!d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('swc-lock');
    if (opener && opener.focus) opener.focus({ preventScroll: true }); opener = null;
  }
  function refresh() { return api('cart.js').then(function (c) { render(c); return c; }); }
  function change(line, q) {
    line.classList.add('is-busy'); msg('');
    return api('cart/change.js', { id: line.dataset.key, quantity: q }).then(render).catch(function (e) { line.classList.remove('is-busy'); msg((e && e.description) || d.dataset.lError); });
  }
  function init() {
    d = document.querySelector('[data-swc]'); if (!d) return;
    panel = $('.swc-panel');
    try { var j = $('[data-swc-cmp]'); cmp = j ? JSON.parse(j.textContent) : {}; } catch (e) { cmp = {}; }
    if (d.dataset.ready) return; d.dataset.ready = '1';
    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-swc-close]')) { close(); return; }
      var line = e.target.closest('.swc-line'); if (!line) return;
      var q = Number(line.dataset.qty);
      if (e.target.closest('[data-swc-inc]')) change(line, q + 1);
      else if (e.target.closest('[data-swc-dec]')) change(line, Math.max(0, q - 1));
      else if (e.target.closest('[data-swc-rm]')) change(line, 0);
    });
    document.addEventListener('keydown', function (e) {
      if (!d.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.pv-head__cart'); if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault(); trust(); open();
      if (!loading) loading = refresh().catch(function () { msg(d.dataset.lError); }).then(function () { loading = null; });
    });
  }
  window.OlySwCart = { open: function () { msg(''); trust(); open(); return refresh(); }, close: function () { close(); }, refresh: function () { return refresh(); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); if (d && d.classList.contains('is-open')) trust(); });
})();
